import { useState } from 'react'

import { Modal } from '@clientbase/clientbase-library'

import ModalInvoiceDetailsContent from 'components/Modal/ModalInvoiceDetails/ModalInvoiceDetailsContent'

interface NfseDetailProps {
  isOpen: boolean
  uuid: string
  onClose: () => void
}

// Abre o detalhe de uma NFSe a partir da busca global. Reusa o conteúdo do
// ModalInvoiceDetails (que recebe o uuid e busca a nota sozinho via DataService,
// sem depender do ChargeContext), só controlando o Modal aqui.
const NfseDetail = ({ isOpen, uuid, onClose }: NfseDetailProps) => {
  const [fullHeight, setFullHeight] = useState(false)

  if (!isOpen) return null

  const handleClose = () => {
    setFullHeight(false)
    onClose()
  }

  return (
    <Modal
      handleClose={handleClose}
      disablePortal={false}
      open={isOpen}
      width="100%"
      maxWidth="85vw"
      maxHeight="90vh"
      {...(fullHeight && { height: '100%' })}
    >
      <ModalInvoiceDetailsContent
        uuid={uuid}
        handleReloadTable={() => undefined}
        handleCloseModal={handleClose}
        setFullHeight={setFullHeight}
      />
    </Modal>
  )
}

export default NfseDetail
